import React, { useEffect, useRef } from "react";
import Hls from "hls.js";

export default function HLSVideo({ src, className, autoPlay = true, loop = true, muted = true }) {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        if (Hls.isSupported()) {
            const hls = new Hls({
                startLevel: 2, // Empezar en una calidad media
                capLevelToPlayerSize: true,
            });
            
            hls.loadSource(src);
            hls.attachMedia(video);
            
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                if (autoPlay) {
                    video.play().catch(e => console.log("HLS autoplay failed:", e));
                }
            });

            return () => {
                hls.destroy();
            };
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
            // Safari soporta HLS de forma nativa
            video.src = src;
            video.addEventListener("loadedmetadata", () => {
                if (autoPlay) {
                    video.play().catch(e => console.log("HLS native autoplay failed:", e));
                }
            });
        }
    }, [src, autoPlay]);

    return (
        <video
            ref={videoRef}
            className={className}
            autoPlay={autoPlay}
            loop={loop}
            muted={muted}
            playsInline
        />
    );
}
